import { useCallback, useContext, useEffect, useRef } from 'react'
import { __RouterContext } from 'react-router'
import { paginationSearch, positivePage, scrollPaginationTop } from 'utils/url-pagination'

const useUrlPagination = ({ enabled = true, defaultPageSize = 20 } = {}) => {
  const router = useContext(__RouterContext)
  const history = router?.history
  const location = router?.location || { pathname: '', search: '' }
  const active = !!history && (typeof enabled === 'function' ? enabled(location.pathname) : enabled)
  const params = new URLSearchParams(location.search)
  const page = active ? positivePage(params.get('page')) : 1
  const pageSize = active ? Math.min(100, positivePage(params.get('per_page'), defaultPageSize)) : defaultPageSize
  const previous = useRef(`${location.pathname}:${page}:${pageSize}`)
  useEffect(() => {
    const signature = `${location.pathname}:${page}:${pageSize}`
    if (active && signature !== previous.current) scrollPaginationTop()
    previous.current = signature
  }, [ active, location.pathname, page, pageSize ])
  const setPage = useCallback((value) => {
    if (!active) return
    const current = history.location
    const oldPage = positivePage(new URLSearchParams(current.search).get('page'))
    const next = typeof value === 'function' ? value(oldPage) : value
    const search = paginationSearch(current.search, next)
    if (search !== current.search) history.push({ ...current, search })
  }, [ active, history ])
  const setPageSize = useCallback((value) => {
    if (!active) return
    const current = history.location
    const search = paginationSearch(current.search, 1, value)
    if (search !== current.search) history.push({ ...current, search })
  }, [ active, history ])
  return { page, pageSize, setPage, setPageSize, active }
}

export default useUrlPagination
